import React from 'react'
import { Navigate } from 'react-router-dom'

import routePath from 'router/routePath'
import { useModuleConfig } from 'hooks/useModuleConfig/useModuleConfig'

type ParkingSpotsGateProps = {
  redirectTo?: string
  children: React.ReactElement
}

/*
  Implements the requirement:
  parking spot can be enabled via module config 'parkingSpots'
*/
export const ParkingSpotsGate: React.FC<ParkingSpotsGateProps> = ({
  children,
  redirectTo = routePath.notFound404,
}) => {
  const { parkingSpots } = useModuleConfig()

  const { enabled } = parkingSpots
  return enabled ? children : <Navigate to={redirectTo} replace />
}
